<template>
  <!-- http://localhost:8080/#/Order/order/flowOrderAdjustPayment -->
  <div>
    <div class="ti d-flex">
      <div class="d-flex-right" style="margin-top: 10px;margin-left: 10px;">
        <el-button @click="selects(1)">查询</el-button>
        <el-button @click="flowexcel()">导出</el-button>
        <!-- 查询条件 -->
        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="查询房产">
              <el-autocomplete
                v-model="house"
                size="mini"
                style="width: 100%;"
                :fetch-suggestions="querySearchAsync"
                placeholder="可搜索房产"
                clearable
                @select="handleSelect"
              ></el-autocomplete>
            </el-descriptions-item>
            <el-descriptions-item label="收费项">
              <el-select v-model="data.select_charge_id" style="width: 100%" clearable size="mini" placeholder="收费项">
                  <el-option
                    v-for="item in chargeitem"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item  label="计费周期">
              <el-date-picker v-model="data.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="data.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item  label="类型">
              <RadioGroup v-model="data.moneyType">
                  <Radio label="全部"></Radio>
                  <Radio label="调整成功账单(流程结束后)"></Radio>
                  <Radio label="调整不成功账单(流程结束后)"></Radio>
              </RadioGroup>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="width: 99%; margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总金费：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;">缴款金额：<span style="color: red;">{{money1}}</span>元</span>
          <span style="margin-left: 15px;">减免金额：<span style="color: red;">{{money3}}</span>元</span>
          <span style="margin-left: 15px;">已减免金额：<span style="color: red;">{{money4}}</span>元</span>
          <span style="margin-left: 15px;">折扣率：<span style="color: red;">{{rate}}</span>%</span>
          <span style="margin-left: 15px;">操作后欠费：<span style="color: red;">{{money2}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <div>
            <el-table ref="multipleTable" height="60vh" :data="orderData" border style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="45" > </el-table-column>
              <el-table-column prop="name" label="业户" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
              <el-table-column prop="chargeItem_name" label="收费标准" width="200"></el-table-column>
              <el-table-column  label="计费周期" width="180">
                <template slot-scope="scope">
                  {{scope.row.startDate}}-{{scope.row.endDate}}
                </template>
              </el-table-column>
              <el-table-column prop="xsc_Price" label="单价" width="100"></el-table-column>
              <el-table-column prop="xsc_Amount" label="数量" width="100"></el-table-column>
              <el-table-column prop="charging" label="面积" width="100"></el-table-column>

              <el-table-column prop="primaryCharge" label="欠费金额" width="80"></el-table-column>
              <el-table-column prop="paymentCharge" label="收款金额" width="100"></el-table-column>
              <el-table-column prop="discountCharge" label="减免金额" width="100"></el-table-column>
              <el-table-column prop="reduce_type_name" label="减免类型" width="120"></el-table-column>
              <el-table-column prop="discount_rate" label="折扣率" width="80"></el-table-column>

              <el-table-column prop="money" label="操作后欠费" width="100"></el-table-column>
              <el-table-column prop="moneys" label="应收金额" width="100"></el-table-column>
              <el-table-column prop="PaidChargeSum" label="已缴金额" width="100"></el-table-column>
              <el-table-column prop="discount" label="已减免金额" width="100"></el-table-column>

              <el-table-column prop="date" label="添加时间" width="150"></el-table-column>
              <el-table-column prop="remark" label="备注" width="150"></el-table-column>
            </el-table>
          </div>
          <div class="pages">
            <el-pagination @size-change="selects_size"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20,50,100,200,300,400,500]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <selectAdiust ref="selectAdiust"></selectAdiust>
  </div>
</template>

<script>
  import imgurl from "../../../../assets/js/imgurl";

  export default {
    data () {
      return {
        task_id:'',
        type:false,
        orderData:[],
        page:1,
        pageSize:20,
        total:0,
        chargeitem:[],
        chargeitems:[],
        order:[],
        money:0,
        money1:0,
        money2:0,
        money3:0,
        money4:0,
        rate:0,
        money_val:0,
        pid:'',
        house:'',
        loading_dade:1,
        number:'',
        data:{
          moneyType:'全部',
          select_charge_id:'',
          chargeItem_name_id:'',
          chargeItem_name_ids:'',
          startDate:'',
          endDate:''
        }
      }
    },
    created(){
       this.number = this.$route.query.number;
       this.selects(1);
    },
    components: {
      "erp-tree": () => import('../../Common/erp-tree-adiust.vue'),
      "selectAdiust": () => import('./selectAdiust.vue'),
    },
    methods: {
       handleSelect(){

       },
       //远程搜索方式
       querySearchAsync(query, cb) {
          if (query !== '') {
            this.loading_dade = 2;
            this.$myhttp.get('admin/common/house_name?house_name='+encodeURIComponent(query),{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.loading_dade = 1;
                let selectList = backdata.data.data;
                let value = [];
                selectList.map(req=>{
                  value.push({'value':req.house})
                })
                cb(value)
            });
          }
       },
       handleSelectionChange(val){
        this.order = val;
        let money = 0;
        this.order.map(req=>{
            money = Number(money) + Number(req.primaryCharge);
        })
        this.money_val = money.toFixed(2);
       },
       handleCurrentChange(e){
         this.page = e;//第几页
         this.selects(this.page);
       },
       selects_size(e){
         this.pageSize = e;
         this.selects(this.page);
       },
       // 查询
       selects(e){
         if(e){
           this.page = e;
         }
         this.chargeitems = [];
         this.data.chargeItem_name_id = '';
         this.data.chargeItem_name_ids = '';
         this.loading_dade = 2;
         let data = {'data':this.data,'house':this.house,'page':this.page,'pid':this.pid,'pageSize':this.pageSize,'number':this.number}
         this.$myhttp.post('admin/OrderPaymentFlow/flowIndex',data,{
           'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata=>{ // 异步执行成功后
             this.orderData = backdata.data.data;
             this.total = backdata.data.count;
             this.money = backdata.data.money;
             this.money1 = backdata.data.money1;
             this.money2 = backdata.data.money2;
             this.money3 = backdata.data.money3;
             this.money4 = backdata.data.money4;
             this.rate = backdata.data.rate;
             this.chargeitem = backdata.data.charge;
             this.loading_dade = 1;
         },err=>{
           this.loading_dade = 1;
           this.$Message.error('请求异常!');
         });
       },

      //导出
      flowexcel(){
        this.$confirm('确定操作吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading_dade = 2;
          this.chargeitems = [];
          this.data.chargeItem_name_id = '';
          this.data.chargeItem_name_ids = '';
          let data = {'data':this.data,'house':this.house,'page':this.page,'pid':this.pid,'pageSize':this.pageSize,'number':this.number}
          this.$myhttp.post('admin/OrderPaymentFlow/flowIndexDaochu',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            if(backdata.data.code != 200){
              this.$Message.error(backdata.data.message);return false;
            }
            this.loading_dade = 1;
            var login = window.localStorage.getItem('login');
            var token = window.localStorage.getItem('token');
            let urls = imgurl+'/'+backdata.data.data+'?'+"&login_name="+login+"&token="+token;
            window.open(urls, '_blank');
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        })
      },
      //点击树
      nodeClick(data){
        this.pid = data.tree[0].pindex_id;
        let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
        this.house=tree_str;
        this.selects(this.page);
      },
    }
  }
</script>

<style>
  .pages{
    width: 100%;
    margin-top: 20px;
  }
  .ti{
    background-color: white;
  }
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
    width: 250px;

  }
  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
  .text2{
    color: rgb(250, 248, 248);
  }
</style>

<style lang="scss" scoped>
  .right-main {
    display: flex;
    // overflow: auto;//体内容的滚动条
    flex: 1;
    background: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/components/Admin/Order/order/flowOrderAdjustPayment.vue